"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colors = require("@mui/material/colors");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const chartId = 'history-chart';
function BikeStationHistoryChart({
  bikeStation,
  history
}) {
  const chartRef = (0, _react.useRef)(null);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  (0, _react.useEffect)(() => {
    async function init() {
      const {
        Chart,
        CategoryScale,
        LinearScale,
        BarController,
        BarElement,
        Tooltip
      } = await Promise.resolve().then(() => _interopRequireWildcard(require('chart.js')));
      Chart.register(CategoryScale, LinearScale, BarController, BarElement, Tooltip);
      Chart.defaults.font.family = '"Roboto", "Helvetica", "Arial", sans-serif';
    }
    init();
  }, []);
  (0, _react.useEffect)(() => {
    let _chart;
    async function update() {
      const {
        Chart
      } = await Promise.resolve().then(() => _interopRequireWildcard(require('chart.js')));
      if (chartRef.current && history) {
        const {
          capacity
        } = bikeStation;
        _chart = new Chart(chartRef.current, {
          type: 'bar',
          data: {
            labels: history.map(({
              date
            }) => date.format('lll')),
            datasets: [{
              label: t('commons.bike_stations.bikes') || '',
              data: history.map(({
                availableClassicBikes
              }) => availableClassicBikes),
              backgroundColor: _colors.blue[900]
            }, {
              label: t('commons.bike_stations.e-bikes') || '',
              data: history.map(({
                availableEBikes
              }) => availableEBikes),
              backgroundColor: _colors.blue[500]
            }, {
              label: t('commons.bike_stations.slots') || '',
              data: history.map(({
                availableLots
              }) => availableLots),
              backgroundColor: _colors.blue[100]
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            scales: {
              x: {
                stacked: true,
                ticks: {
                  callback: (val, index) => history[index].date.format('LT')
                }
              },
              y: {
                beginAtZero: true,
                max: capacity,
                stacked: true
              }
            },
            interaction: {
              mode: 'index'
            }
          }
        });
      }
    }
    update();
    return () => {
      if (_chart) _chart.destroy();
    };
  }, [history, chartRef.current]);
  return /*#__PURE__*/_react.default.createElement(StyledChart, {
    height: 130,
    id: chartId,
    ref: chartRef
  });
}
const StyledChart = _styledComponents.styled.canvas`
  margin-top: 16px;
  width: 100%;
`;
var _default = exports.default = BikeStationHistoryChart;